<template>
  <form class="af-card" @submit.prevent="doSubmit" autocomplete="new-password">
    <div class="p-3">
      <div class="is-size-4 has-text-grey-icon">
        <span v-if="!!customerFirstName">
          {{ "Szia " + customerFirstName + "!" }}
        </span>
        <span v-else> {{ "Szia!" }} </span>
      </div>
      <div class="is-size-3 has-text-weight-bold mt-1 mb-4">
        {{ "Lépj be a folytatáshoz!" }}
      </div>
      <div class="has-text-grey mb-5">
        {{
          "A megadott telefonszámodra SMS-ben érkezik majd a belépéshez szükséges egyedi azonosító."
        }}
      </div>

      <validation-observer ref="codeObserver">
        <BInputWithValidation
          :label="'SMS-ben kapott kód'"
          rules="required"
          label-position="on-border"
          autocomplete="new-password"
          :name="name"
          v-model="code"
        />
      </validation-observer>

      <b-field>
        <b-button
          type="is-blue"
          native-type="submit"
          expanded
          :loading="loading"
          >{{ $t("af:login.second_factor.button.next") }}</b-button
        >
      </b-field>
      <p
        v-if="timer === 0"
        @click="reSendTwoFactor()"
        class="has-text-centered has-text-weight-bold is-link"
      >
        Megerősítő kód újraküldése
      </p>
      <p v-else class="has-text-centered has-text-grey">
        <b-icon icon-pack="fa" icon="info-circle"></b-icon>
        <span class="has-text-grey-icon is-size-6">{{
          timer + " másodperc múlva kérhetsz új kódot"
        }}</span>
      </p>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "@/plugins/i18n";
import {
  clearLandingParams,
  getActiveLandingParams,
} from "../utils/landingParamUtil";
import twoFactorMixin from "../mixins/twoFactorMixin";

export default {
  name: "LoginSecondFactor",
  title: "af:page.login.second_factor.title",
  mixins: [twoFactorMixin],
  components: {
    BInputWithValidation: () => import("@/components/BInputWithValidation.vue"),
  },
  data() {
    return {
      code: "",
      secondFactorId: "",
      secondFactorNonce: "",
      name: (Math.random() + 1).toString(36).substring(5),
      customerFirstName: null,
      loading: false,
      timer: 61,
    };
  },
  computed: {
    ...mapGetters({
      secondFactor: "session/secondFactor",
      loggedIn: "session/isReady",
    }),
    isLeasing() {
      return /^\/leasing.*/i.test(this.$route.path);
    },
  },
  async mounted() {
    if (this.loggedIn) {
      await this.$router.push("/user/profile");
    } else if (!this.secondFactor) {
      if (this.isLeasing) {
        await this.$router.push("/leasing/login");
      } else {
        await this.$router.push("/login");
      }
    } else {
      this.secondFactorId = this.secondFactor.id;
      this.secondFactorNonce = this.secondFactor.nonce;
      this.customerFirstName = this.secondFactor.customerFirstName;

      this.startCountDown();
      await this.$store.dispatch("session/deleteSecondFactor");
    }
  },
  methods: {
    async doSubmit() {
      try {
        const valid = await this.$refs.codeObserver.validate();
        if (!valid) return;
        this.loading = true;

        this.track();

        let solution = {
          id: this.secondFactorId,
          code: this.code,
          nonce: this.secondFactorNonce,
          landingParams: getActiveLandingParams(),
        };

        let redirect = await this.finishLogin(solution);

        await this.$router.push(redirect);

        clearLandingParams();
      } catch (ex) {
        this.$buefy.toast.open({
          message: i18n.t("af:login.error.general"),
          type: "is-danger",
        });
        console.error(ex);
      }

      this.loading = false;
    },
    track() {
      this.$gtag.event("login_2fa");
    },
  },
};
</script>

<style scoped lang="scss">
.af-card {
  background: white;
  border-radius: 16px;
  padding: 20px;

  .dealer-branding-wrapper & {
    border-radius: var(--border-radius);
    box-shadow: 0px 0px 20px 10px #0000000a;
  }
}

@media only screen and (min-width: 769px) {
  .af-card {
    padding: 32px 36px;
  }
}

.is-link {
  color: #1072fc;
  cursor: pointer;

  .dealer-branding-wrapper & {
    color: var(--branding-secondary);
  }
}
</style>
